import { useMemo } from 'react'
import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useMenuOutboundLayoutContext } from 'widgets/Menu/ui/MenuOutbound'
import { PowerDialerPageContext } from 'pages/powerDialer/context/powerDialerPageContext'
import { PowerDialerPageStore } from 'pages/powerDialer/store/powerDialerPageStore'

export const PowerDialerLayout = observer(() => {
  const menuLayoutStore = useMenuOutboundLayoutContext()
  const pageStore = useMemo(() => new PowerDialerPageStore(menuLayoutStore.pageLayoutStore), [])

  return (
    <PowerDialerPageContext.Provider value={pageStore}>
      <Outlet />
    </PowerDialerPageContext.Provider>
  )
})
